import React from "react";
import { IconProps } from "./types";

export default function ChevronRightIcon({
  width = 24,
  height = 24,
  className = "",
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <g clipPath="url(#clip0_57687_2004)">
        <path
          d="M8.33345 5.10352L7.15845 6.27852L10.9751 10.1035L7.15845 13.9285L8.33345 15.1035L13.3334 10.1035L8.33345 5.10352Z"
          fill="#DEE0E3"
        />
      </g>
      <defs>
        <clipPath id="clip0_57687_2004">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.103516)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
